<div class="fs-2 success with-close" mat-dialog-title>
    Félicitations !
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b class="subtitle">Votre {{mode}} a bien été créée.</b>
    <div class="svg_wrapper alert-list">

        <img class="svg_alert-mail" src="https://www.lybox.fr/build/images/svg/alert-mail.svg" alt="Alerte mail"
             width="100">
        <img class="svg_mail-notif" src="https://www.lybox.fr/build/images/svg/mobile-notification.svg"
             alt="Alerte mail">
        <b>
            Vous recevrez directement dans votre boite mail les nouvelles annonces.<br/>
            Vous pouvez gérer votre alerte en cliquant sur le bouton “Gérer mon alerte” en haut à droite
        </b>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline w-100">
        Fermer
    </button>
</div>
